import LottieView from "lottie-react-native";
import { View } from "react-native";
import { Text } from "react-native-paper";

import { Button, Modal } from "../../components";
import { PaymentMethod } from "./OrderForm/types";

type Props = {
  onEnroll?(): void;
  onClose(): void;
  visible: boolean;
  paymentMethod?: PaymentMethod;
  email?: string;
};

const getPaymentDetails = (paymentMethod?: PaymentMethod, email?: string) => {
  switch (paymentMethod) {
    case PaymentMethod.Card:
      return {
        title: "Payment Complete",
        description: `Your payment has been processed. ${email ? `A receipt has been sent to ${email}.` : ""}`,
      };

    case PaymentMethod.Bank:
      return {
        title: "Payment Submitted",
        description: "Please allow up to 5 business days to process payments made by bank account.",
      };
    default:
      return { title: null, description: null };
  }
};

export default function SuccessModal({ onClose, paymentMethod, email, visible }: Props) {
  const { title, description } = getPaymentDetails(paymentMethod, email);

  return (
    <Modal visible={visible} onDismiss={onClose} title="">
      <View className="pt-12 items-center justify-between px-10 py-6 bg-sky-white" testID="ActivityReviewSuccessModal">
        <View className="items-center">
          <View className="w-28 h-28">
            <LottieView style={{ flex: 1 }} autoPlay source={require("../../../assets/lottie-icons/verified.json")} />
          </View>
          <Text className="text-title-2 font-700 text-ink-darkest mt-8 text-center">{title}</Text>
          <Text className="text-regular-normal font-400 text-ink-dark my-6 px-4 text-center">{description}</Text>
        </View>

        <View className="w-full mb-4 mt-8">
          <Button mode="secondary" onPress={onClose}>
            Close
          </Button>
        </View>
      </View>
    </Modal>
  );
}
